import React from "react";
import {
    Pagination as PaginationUI,
    PaginationContent,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "@/components/common/table/pagination";
import { cn } from "@/utils/css";

export const Pagination = ({
    currentPage,
    totalPages,
    itemsPerPage,
    totalItems,
    onPageChange,
    className = "",
    showItemsInfo = true,
    itemsLabel = "items",
}) => {
    if (totalPages <= 1) return null;

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

    const renderPageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3);
                pages.push("ellipsis");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push("ellipsis");
                for (let i = totalPages - 3; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1);
                pages.push("ellipsis");
                pages.push(currentPage - 1, currentPage, currentPage + 1);
                pages.push("ellipsis");
                pages.push(totalPages);
            }
        }

        return pages.map((page, index) => (
            <PaginationItem key={index}>
                {page === "ellipsis" ? (
                    <span className="flex h-9 w-9 items-center justify-center text-cm-text-secondary">...</span>
                ) : (
                    <PaginationLink onClick={() => onPageChange(page)} isActive={currentPage === page} className="cursor-pointer">
                        {page}
                    </PaginationLink>
                )}
            </PaginationItem>
        ));
    };

    return (
        <div className={cn("flex flex-col justify-end items-center w-full gap-4 lg:flex-row lg:gap-0 relative h-10", className)}>
            <PaginationUI
                className={cn({
                    "lg:absolute top-0 left-0": showItemsInfo,
                })}
            >
                <PaginationContent>
                    <PaginationItem>
                        <PaginationPrevious
                            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                            className={cn("cursor-pointer", currentPage === 1 && "pointer-events-none opacity-50")}
                        />
                    </PaginationItem>

                    {renderPageNumbers()}

                    <PaginationItem>
                        <PaginationNext
                            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                            className={cn("cursor-pointer", currentPage === totalPages && "pointer-events-none opacity-50")}
                        />
                    </PaginationItem>
                </PaginationContent>
            </PaginationUI>

            {showItemsInfo && (
                <div className="flex items-center justify-center lg:justify-end">
                    <span className="text-cm-text-secondary text-sm/[22px] whitespace-nowrap">
                        Showing {startIndex + 1}-{endIndex} of {totalItems} {itemsLabel}
                    </span>
                </div>
            )}
        </div>
    );
};
